import React from "react";
import PropTypes from "prop-types";
import "./Header2.less";
import { getUserRole, parseQueryString, setHashParam } from "../../lib";
import { isUserAdmin } from "../../lib/appPermissions";
import NavTabs from "../NavTabs";
import { oktaSignOut } from "../../auth/oktaSignOut";

export default class Header2 extends React.Component {
    static propTypes = {
        settings: PropTypes.object.isRequired,
        query: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        urlParams: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            dropdownOpen: false
        };
        this.dropdownRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
            this.setState({ dropdownOpen: false });
        }
    }

    handleLogout = () => {
        oktaSignOut();
    };


    render() {
        const _query = parseQueryString(this.props.location.search);
        let _tab = _query._tab || "";

        return (
            // <div className="app-header">
            <div style={{ flexDirection: "row" }}>
                {/* <label
                    className="pull-right advanced-label text-danger logout-label"
                    onClick={this.handleLogout}
                >
                    Logout
                </label> */}
                <div className="pull-right user-dropdown" ref={this.dropdownRef} style={{ top: '0.25rem', right: "0.5rem", position: 'relative' }}>
                    <i
                        className="fa fa-user-circle"
                        style={{ fontSize: '24px', color: '#d9534f', cursor: 'pointer' }}
                        onClick={() => this.setState({ dropdownOpen: !this.state.dropdownOpen })}
                    />
                    {this.state.dropdownOpen && (
                        <div style={{
                            position: 'absolute',
                            right: 0,
                            top: '100%',
                            marginTop: '5px',
                            backgroundColor: '#fff',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            minWidth: '180px',
                            zIndex: 1000000000
                        }}>
                            {isUserAdmin(getUserRole()) && (
                                <div
                                    onClick={() => {
                                        this.setState({ dropdownOpen: false });
                                        window.location.href = "/user-management";
                                    }}
                                    style={{
                                        padding: '8px 15px',
                                        cursor: 'pointer',
                                        color: '#333'
                                    }}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                >
                                    <i className="fa fa-user" /> User Management
                                </div>
                            )}
                            <div
                                onClick={() => {
                                    this.setState({ dropdownOpen: false });
                                    window.location.href = "/mirth-audit-log";

                                }}
                                style={{
                                    padding: '8px 15px',
                                    cursor: 'pointer',
                                    color: '#333'
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                            >
                                <i className="fa fa-history" /> Audit Log
                            </div>
                            <div
                                onClick={() => {
                                    this.setState({ dropdownOpen: false });
                                    this.handleLogout();
                                }}
                                style={{
                                    padding: '8px 15px',
                                    cursor: 'pointer',
                                    color: '#333'
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                            >
                                <i className="fa fa-sign-out" /> Logout
                            </div>
                        </div>
                    )}
                </div>
                <NavTabs
                    settings={this.props.settings}
                    query={this.props.query}
                    currentTab={_tab}
                    isAdvanced={false}
                />
            </div>
            // </div>
        );
    }
}
